import { createGlobalState } from '@vueuse/core';
import { ref, nextTick } from 'vue';
import { useToasted } from '~/composables/useToasted';
import { orgUnitsClient } from '~/services';
import { catchRequestError } from '~/utils/request';

export const useOrgUnitDetails = createGlobalState(() => {
    const toasted = useToasted();
    const teamId = Spark.state.currentTeam.id;

    const orgUnit = ref();
    const loading = ref(true);

    let onMountedOrgUnitCallback = () => {};
    const onMountedOrgUnit = (callback) => {
        onMountedOrgUnitCallback = callback;
    };

    const mount = async (orgUnitId) => {
        await nextTick();

        try {
            loading.value = true;
            const response = await orgUnitsClient.showOrgUnit(teamId, orgUnitId);
            orgUnit.value = response.data;
            loading.value = false;
            onMountedOrgUnitCallback?.();
        } catch (e) {
            toasted?.error(catchRequestError(e));
        }
    };

    const unmount = () => {
        orgUnit.value = undefined;
        loading.value = false;
    };

    return {
        loading,
        orgUnit,
        mount,
        unmount,
        onMountedOrgUnit,
    };
});
